
import { Vue, Component, Prop } from "vue-property-decorator";

interface TransportationMethod {
  transportation_type: string;
  id: string;
  __typename: string;
}

interface TravelTimes {
  driving?: string;
  transit?: string;
  bicycling?: string;
  walking?: string;
}

@Component
export default class TransportationMethodIcons extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly availableTransportation!: TransportationMethod[];
  @Prop({ type: Boolean, default: true }) readonly showIcons!: boolean;
  @Prop({ type: Object, default: () => ({}) }) readonly travelTimes!: TravelTimes;
  @Prop({ type: Boolean, default: false }) readonly hasOverlappingVisit!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly conflictingMethods!: string[];

  get shouldShowIcons(): boolean {
    return this.showIcons && this.availableTransportation && this.availableTransportation.length > 0;
  }

  get shouldShowTravelTimes(): boolean {
    // Always show travel times, even for overlaps or conflicts (so users can see the red times)
    return true;
  }

  get iconClasses(): string {
    return "w-6 h-6"; // Base classes only, color handled per icon
  }

  getIconColorClasses(transportationType: string): string {
    const baseClasses = "w-6 h-6";
    let colorClass = "text-gray-600"; // Default color
    
    if (this.hasOverlappingVisit) {
      colorClass = "text-red-600"; // Red for overlapping visits
    } else if (this.hasConflict(transportationType)) {
      colorClass = "text-red-600"; // Red for travel time conflicts
    }
    
    return `${baseClasses} ${colorClass}`;
  }

  hasConflict(transportationType: string): boolean {
    return this.conflictingMethods.includes(transportationType);
  }

  hasTransportationType(type: string): boolean {
    return this.availableTransportation.some(
      (transport) => transport.transportation_type === type
    );
  }

  getTravelTime(travelMode: string): string {
    if (this.hasOverlappingVisit) {
      return '';
    }
    const raw = this.travelTimes[travelMode];
    if (!raw) return '';
    const time = typeof raw === 'string' ? raw.trim() : raw;
    // Hide any N/A (any casing), zero-minute values, or exact 'N/A' strings
    if (!time || time === 'N/A' || /^n\/?a$/i.test(time.replace(/\s+/g, '')) || time.toLowerCase() === 'n/a' || time === '0 min' || time === '0 mins') {
      return '';
    }
    return time;
  }
}
